import * as React from "react";
import { IdPremiumType } from "../../constants/IdPremiumType";
import { IdStyles } from "../../less/IdStyles";
import { utilButton } from "../../utils/utilButton";
import { GridItemContainerDefault } from "../generic/common/GridItemContainerDefault";
import { GridItemContainerDefaultPremium } from "../generic/common/GridItemContainerDefaultPremium";
import { GridItemContainerPremiumSpecial } from "../generic/common/GridItemContainerPremiumSpecial";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var GridItemProducts = React.memo(function (_a) {
    var item = _a.item, onClick = _a.onClick, className = _a.className;
    var premiumType = item.premiumType, amount = item.amount;
    var resourceIcon = getResourceIcon(item);
    var GridItemComponent = GridItemContainerDefault;
    if (premiumType && premiumType === IdPremiumType.Blue) {
        GridItemComponent = GridItemContainerDefaultPremium;
    }
    if (premiumType && premiumType === IdPremiumType.Purple) {
        GridItemComponent = GridItemContainerPremiumSpecial;
    }
    return (React.createElement(GridItemComponent, { className: className, onClick: function () { return utilButton.onClickWithSound(onClick); } },
        React.createElement("div", { className: "farm-management-master__item" },
            React.createElement(Icon, { icon: resourceIcon, styleId: IdStyles.IconExtraLarge }),
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(NumberFormat, { amount: amount })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/GridItemProducts.tsx
// module id = 2655
// module chunks = 3